import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));

/**
 * Description: Entry point for the React application.
 * Initializes the React root and renders the main App component in strict mode for development warnings.
 */
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

/**
 * Description: Reports web vitals metrics (performance metrics) for monitoring app performance.
 * This helps identify performance issues and can be sent to analytics endpoints.
 */
reportWebVitals();
